import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import Layout from "../../components/global/layout";
import methodModel from "../../methods/methods";
import loader from "../../methods/loader";

const SMSPolicy = () => {
    const [content, setContent] = useState({});
    const slug = "sms-policy";

    useEffect(() => {
        getDetail()
    }, [slug])

    const getDetail = () => {
        loader(true)
        ApiClient.get(`content/detail?slug=${slug}&status=active`).then(res => {
            if (res.success) {
                setContent(res.data)
            }
            loader(false)
        })
    }

    return (
        <Layout>
            <div className="bg-white py-10 lg:py-20">
                <div className="2xl:container 2xl:mx-auto lg:py-16 lg:px-20 md:py-12 md:px-6 py-9 px-4">
                    <div className="flex lg:flex-row flex-col lg:gap-8 sm:gap-10 gap-12">
                        <div className="w-full lg:w-6/12">
                            <h2 className="w-full font-bold lg:text-4xl text-3xl lg:leading-10 leading-9">{content?.title}</h2>
                            <div dangerouslySetInnerHTML={{ __html: content?.description }} className="font-normal text-base leading-6 text-gray-600 mt-6" />
                        </div>
                        <div className="w-full lg:w-6/12">
                            {content?.image ? (
                                <img
                                    src={methodModel.noImg(content?.image)}
                                    alt={content?.title}
                                    className="h-96 w-full object-contain mx-auto mb-4"
                                />
                            ) : (
                                <div className="text-center text-gray-500"></div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default SMSPolicy;